module.exports = __webpack_public_path__ + "media/images/Endecott-coin-1a copy-fa6972293bab70d3710dde5593c11468.jpg";